import { useTranslation } from 'react-i18next'

import styles from './DormTabs.module.scss'

const DormTabs = ({ tab, setTab }) => {
  const { t } = useTranslation('common')

  return (
    <div className={styles.toolbar}>
      <h2 className={styles.title}>{t('dorm.title_page')}</h2>
      <div className={styles.tabs}>
        <div
          className={`${styles.tab} ${tab === 'rooms' ? styles.active : ''}`}
          onClick={() => setTab('rooms')}
        >
          {t('dorm.tab_rooms')}
        </div>
        <div
          className={`${styles.tab} ${tab === 'buildings' ? styles.active : ''}`}
          onClick={() => setTab('buildings')}
        >
          {t('dorm.tab_buildings')}
        </div>
        <div
          className={`${styles.tab} ${tab === 'occupancies' ? styles.active : ''}`}
          onClick={() => setTab('occupancies')}
        >
          {t('dorm.tab_occupancies')}
        </div>
        <div
          className={`${styles.tab} ${tab === 'incidents' ? styles.active : ''}`}
          onClick={() => setTab('incidents')}
        >
          {t('dorm.tab_incidents')}
        </div>
      </div>
    </div>
  )
}

export default DormTabs
